import React, {useState} from "react"
import swal from "sweetalert"
import "./Section.10.Fields.css"

export default function FieldsSection(params) {

    const {rescue} = params
    const [name, setName] = useState("")
    const [value, setValue] = useState("")
    
    const addField = () => {
        if (!name || !value) {
            swal("Greška", "Fali vrednost polja", "warning")
            return
        }
       	const field = {name, value}
       	let updated = rescue.rescue?.fields?.filter(field => field.name !== name) ?? []
       	updated = [...updated, field]
       	rescue.setField("fields", updated)
    }
    
    const removeField = () => {
        const updated = rescue.rescue?.fields?.filter(field => field.name !== name)
        rescue.setField("fields", updated)
    }
    
    const setPair = (event) => {
        const name = event.target.getAttribute('data-name')
        setName(name)
        setValue("")
    }
    
    return <li className="accordion" id="accordion-fields">
        <input type="checkbox" className="accordion" name="accordion" id="acc-fields"/>
        <label className="accordion" htmlFor="acc-fields">Dodatna polja</label>
        <section className="accordion">
      		{!rescue.isReadOnly && <p>
          		Ovde idu dodatna polja koja se prikazuju na povrednoj listi.<br/>
          		Recimo, za OPU akcije, to mogu biti
          		<button data-name="Broj planinarske knjižice" onClick={setPair}>Broj planinarske knjižice</button>,
          		<button data-name="Planinarski klub" onClick={setPair}>Planinarski klub</button>,
          		<button data-name="Planinarski vodič" onClick={setPair}>Planinarski vodič</button> i
          		<button data-name="Broj licence" onClick={setPair}>Broj licence</button>.
      		</p>}
        
            {rescue.rescue.fields?.length > 0 ? <ul id="additional-fields">
                {rescue.rescue.fields?.map(pair => <li key={pair.name} className="one-field">{pair.name}: <span className="field-value">{pair.value}</span></li>)}
            </ul> : <p>
                Nema dodatnih polja
            </p>}
          
            {!rescue.isReadOnly && <div className="field" id="add-field">
       		    <label htmlFor="additional_name" className="above">Dodatno polje</label>
           		<input type="text" value={name} placeholder="Naziv polja" onChange={event => setName(event.target.value)}/>
           		<input type="text" value={value} placeholder="Vrednost" onChange={event => setValue(event.target.value)}/>
           		<div id="field-buttons">
                    <button className="btn btn-primary btn-sm" onClick={addField}><i className="fas fa-plus"/>&nbsp;&nbsp;Dodaj polje</button>
                    <button className="btn btn-primary btn-sm" onClick={removeField}><i className="fas fa-minus"/>&nbsp;&nbsp;Izbaci polje</button>
                </div>
           	</div>}
          
        </section>
    </li>   
    
}